import { render, staticRenderFns } from "./add_org_types.vue?vue&type=template&id=590cc775&scoped=true&"
import script from "./add_org_types.vue?vue&type=script&lang=js&"
export * from "./add_org_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590cc775",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590cc775')) {
      api.createRecord('590cc775', component.options)
    } else {
      api.reload('590cc775', component.options)
    }
    module.hot.accept("./add_org_types.vue?vue&type=template&id=590cc775&scoped=true&", function () {
      api.rerender('590cc775', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/advanced/add_org_types.vue"
export default component.exports